const locale = {
  name: "gregorian_ar",
  months: [
    ["يناير", "ينا"],
    ["فبراير", "فبر"],
    ["مارس", "ما"],
    ["إبريل", "إبر"],
    ["مايو", "ما"],
    ["يونيو", "يو"],
    ["يوليو", "يوليو"],
    ["أغسطس", "أغس"],
    ["سبتمبر", "سب"],
    ["أكتوبر", "اک"],
    ["نوفمبر", "نو"],
    ["ديسمبر", "دس"],
  ],
  weekDays: [
    ["السّبت", "سب"],
    ["الأحد", "اح"],
    ["الإثنينِ", "ثن"],
    ["الثلاثاء", "ثل"],
    ["الأربعاء", "ار"],
    ["الخميس", "خم"],
    ["الجمعة", "جم"],
  ],
  digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
  meridiems: [
    ["قبل الظهر", "ق.ظ"],
    ["بعد الظهر", "ب.ظ"],
  ],
};

export default locale;
